/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @file Insight to display billable hours.
 * @author Maarten Lensink
 * @customer Rembrandthuis
 * @issue 3644

 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".sym-insight-text[_ngcontent-%COMP%]   .sym-text-box[_ngcontent-%COMP%]{text-align:center;height:40px;margin-left:20px;margin-right:20px}.sym-insight-text[_ngcontent-%COMP%]   .sym-icon-box[_ngcontent-%COMP%]{font-size:4rem;text-align:center;margin-left:30px;margin-right:30px}.sym-insight-text[_ngcontent-%COMP%]   .sym-icon-box[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{color:#f3a357}"];
export { styles as styles };
